import React, { useLayoutEffect, useRef, useState } from "react";

/**
 * ApexCharts can emit NaN SVG dimensions when width is "100%" while the
 * parent still has no laid-out width (flex, tabs, modal transitions).
 * Measure the container and pass a numeric width into Chart.
 */
const ResponsiveApexContainer = ({ height, children }) => {
	const ref = useRef(null);
	const [width, setWidth] = useState(0);

	useLayoutEffect(() => {
		const el = ref.current;
		if (!el) return;

		const read = () => {
			const w = Math.floor(el.getBoundingClientRect().width);
			setWidth(prev => (prev !== w ? w : prev));
		};

		read();
		const ro = new ResizeObserver(read);
		ro.observe(el);
		return () => ro.disconnect();
	}, []);

	return (
		<div
			ref={ref}
			className="responsive-apex-container"
			style={{ width: "100%", minWidth: 0 }}
		>
			{width > 0 ? children(width) : (
				<div style={{ height }} aria-hidden />
			)}
		</div>
	);
};

export default ResponsiveApexContainer;
